export const getHat = (hat, customHat) => {
    let defaultHat = 'Artigo';

    if (customHat?.length > 0) {
        return customHat;
    }

    if (hat?.length === 0 && customHat?.length === 0) {
        return defaultHat;
    }

    return hat;
};
